/* eslint-disable import/extensions, import/no-relative-packages, react/prop-types */
import React from 'react';
import { TextLink as PestoTextLink } from '../../node_modules/@feast-it/pesto/dist/index.esm.js';

export * from '../../node_modules/@feast-it/pesto/dist/index.esm.js';

const DefaultLink = React.forwardRef(
  ({ as: Component = 'a', children, href, ...props }, ref) => (
    <Component ref={ref} href={href} {...props}>
      {children}
    </Component>
  )
);

DefaultLink.displayName = 'PestoCompatDefaultLink';

export const TextLink = React.forwardRef(
  ({ linkComponent = DefaultLink, ...props }, ref) => (
    <PestoTextLink ref={ref} linkComponent={linkComponent} {...props} />
  )
);

TextLink.displayName = 'PestoCompatTextLink';
